var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReading3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.70215V12.8001C18.5 13.2201 18.5 13.4301 18.5817 13.5905C18.6537 13.7317 18.7684 13.8464 18.9095 13.9183C19.0699 14.0001 19.28 14.0001 19.7 14.0001H22.7979M14.75 20L16.25 21.5L19.625 18.125M18.5 9.5H14.6C13.3399 9.5 12.7098 9.5 12.2285 9.74524C11.8052 9.96095 11.461 10.3052 11.2452 10.7285C11 11.2098 11 11.8399 11 13.1V20.9C11 22.1601 11 22.7902 11.2452 23.2715C11.461 23.6948 11.8052 24.039 12.2285 24.2548C12.7098 24.5 13.3399 24.5 14.6 24.5H19.4C20.6601 24.5 21.2902 24.5 21.7715 24.2548C22.1948 24.039 22.539 23.6948 22.7548 23.2715C23 22.7902 23 22.1601 23 20.9V14L18.5 9.5Z",
    stroke: "#1ED214",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReading3);
export default __webpack_public_path__ + "static/media/reading3.90b91c643e42fe865a0600f1ba42183e.svg";
export { ForwardRef as ReactComponent };